<template>
  <header class="chart-header">
    <a href="/contents">
      <Logo class="chart-header__logo" />
    </a>

    <a href="/contents" class="chart-header__link-back btn btn--xs btn--secondary">
      <LeftArrow class="chart-header__link-back-icon" />
      Back
    </a>
  </header>
</template>

<script>
import Logo from "@images/svgs/header_logo.svg";
import LeftArrow from "@images/font_awesome/long-arrow-left-light.svg";

export default {
  name: "BlankHeader",
  components: {
    Logo,
    LeftArrow
  }
}
</script>

<style lang="scss">
.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__logo {
    display: flex;
    align-items: center;
  }

  &__link-back-icon {
    display: block;
    width: $px16;
    height: $px16;
    margin-right: $px8;

    color: $grey-1;
  }

  &__link-back {
    display: flex;
    align-items: center;

    @include font-small;
    color: $grey-1;
    text-decoration: none;
  }
}
</style>
